import type RecordService from '../../../record/record.service';
import type {RecordCreateParams, RecordSearchParams} from 'typings/portaro.be.types';

/**
 * @ngdoc service
 * @name recordValueEditorService
 * @module portaro.value-editors
 *
 * @description
 * Service for record value editor.
 */
export default class RecordValueEditorService {
    public static readonly serviceName = 'recordValueEditorService';

    /*@ngInject*/
    constructor(private recordService: RecordService) {
    }

    public async searchModelFunction(model, searchParams: RecordSearchParams, createParams: RecordCreateParams) {
        return this.recordService.findRecord(searchParams, createParams);
    }

    public editModelFunction(model, createParams: RecordCreateParams) {
        return this.recordService.createNewRecord(createParams, model);
    }
}